import { render } from "./SelectLesson.vue?vue&type=template&id=48bb7bd4&scoped=true"
import script from "./SelectLesson.vue?vue&type=script&lang=js"
export * from "./SelectLesson.vue?vue&type=script&lang=js"

import "./SelectLesson.vue?vue&type=style&index=0&id=48bb7bd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb7bd4"]])

export default __exports__